import { notification } from 'antd';
import network from './network';

export default {
  getUserInfo() {
    return network.get('api/auth/info');
  },
  // 根据uid获取用户权限详情，不是当前用户
  getUserAuth(userId) {
    return network.get(`api/auth/allAuthority/${userId}`);
  },
  login(userId, password) {
    return network.login({ userId, password }).then((data) => {
      notification.success({ message: '登录成功' });
      return data;
    }, () => {
      notification.error({ message: '登录失败', description: '请检查账号或密码' });
    });
  },
  getDingTalkConfig() {
    return network.getDingTalkConfig();
  },
  dingTalkInternalLogin(authCode) {
    return network.dingTalkInternalLogin(authCode);
  },
  logout() {
    return network.logout().then((data) => {
      notification.success({ message: '注销成功' });
      return data;
    }, () => {
      notification.error({ message: '注销失败' });
    });
  },
  deleteUserAuth(userId, data) {
    return network.delete(`api/auth/authority/${userId}`, data);
  },
  addUserAuth(userId, data) {
    return network.put(`api/auth/authority/${userId}`, data);
  },
  /*
    全量重置权限
    {
      "authority": "INSPECTION_REVIEW_CUSTOM_COMPANY",
      "list": ["4", "30", "32"]
    }
  */
  resetUserAuth(userId, data) {
    return network.post(`api/auth/authority/${userId}`, data).then(() => {
      notification.success({ message: '设置成功' });
    }, (err) => {
      notification.error({ message: '设置失败', description: '请联系管理员' });
      return Promise.reject(err);
    });
  },
  resetMultiUserAuth(userId, dataList) {
    Promise.all(dataList.map(data => network.post(`api/auth/authority/${userId}`, data))).then(() => {
      notification.success({ message: '设置成功' });
    }, () => {
      notification.error({ message: '设置失败', description: '请联系管理员' });
    });
  },
};
